import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AgreementProductItem } from 'src/app/api/models';

/** Valore del menu per "fuori commessa" (le righe commessa hanno id positivi). */
export const OUT_OF_AGREEMENT = 0;

export interface AmbiguousProductChoice {
  product_id: number;
  product_name: string;
  candidates: AgreementProductItem[];
}

interface ChoiceRow extends AmbiguousProductChoice {
  options: { id: number; label: string }[];
  selected?: number;
}

/**
 * Finestra di scelta quando un prodotto ha più righe nella commessa: per ogni prodotto
 * si sceglie una delle righe di commessa oppure "Fuori commessa".
 * Si chiude con { value: { [product_id]: id riga commessa | null (fuori commessa) } },
 * oppure senza valore se l'utente annulla.
 */
@Component({
  selector: 'app-modal-select-agreement-product',
  templateUrl: './modal-select-agreement-product.component.html',
  styleUrls: ['./modal-select-agreement-product.component.scss'],
})
export class ModalSelectAgreementProductComponent {
  rows: ChoiceRow[];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    const items: AmbiguousProductChoice[] = config.data?.items ?? [];
    this.rows = items.map(item => ({
      ...item,
      options: [
        { id: OUT_OF_AGREEMENT, label: 'Fuori commessa' },
        ...item.candidates.map(c => ({
          id: c.id,
          label: ModalSelectAgreementProductComponent.label(c),
        })),
      ],
      selected: undefined,
    }));
  }

  static label(c: AgreementProductItem): string {
    const parts = [c.name ?? c.agreement_code];
    if (c.agreement_code && c.name) parts.push(`codice commessa ${c.agreement_code}`);
    if (c.part_number) parts.push(`P/N ${c.part_number}`);
    if (c.code_internal) parts.push(`(${c.code_internal})`);
    return parts.filter(Boolean).join(' - ');
  }

  get canConfirm(): boolean {
    return (
      this.rows.length > 0 && this.rows.every(r => r.selected !== undefined && r.selected !== null)
    );
  }

  close() {
    this.ref.close();
  }

  confirm() {
    const value: Record<number, number | null> = {};
    for (const r of this.rows) {
      value[r.product_id] = r.selected === OUT_OF_AGREEMENT ? null : (r.selected as number);
    }
    this.ref.close({ value });
  }
}
